/**
 * FormPager — contador de fichas ‹ n / total › del topbar.
 *
 * POR QUÉ EXISTE
 * ---------------------------------------------------------------------------
 * Cada ficha había copiado su propio paginador (servidores, chasis, cabinas,
 * firewalls, routers, SAIs, puertos, APs, controladores…). Con copias, unas
 * llevaban `saving`, otras no, y el resto de fichas simplemente no lo tenía.
 * Aquí vive el único paginador: mismo aspecto, mismo aria, mismo
 * comportamiento en todas las fichas (estándar `docs/FICHA_ESTANDAR_TARJETAS.md`
 * §3.1 — a la izquierda, pegado a la migaja, nunca en las acciones).
 *
 * El ORDEN lo decide el listado (`items` viene ya filtrado y ordenado, y
 * congelado con `useNavOrder` para que guardar no reordene la secuencia).
 *
 * Uso:
 *   <FormPager
 *     items={navItems}
 *     index={navIndex}
 *     label="Servidor"
 *     disabled={saving}
 *     onChange={(destino) => irANav(destino)}
 *   />
 *
 * `onChange` recibe el REGISTRO destino (no el índice): el listado abre la
 * ficha de ese registro, igual que hace el botón «siguiente» de siempre.
 */
import React from 'react';

export default function FormPager({
  items = [],
  index = -1,
  onChange,
  label = 'Ficha',
  disabled = false,
  className = '',
}) {
  if (!Array.isArray(items) || items.length < 2 || index < 0) return null;

  const prev = index > 0 ? items[index - 1] : null;
  const next = index < items.length - 1 ? items[index + 1] : null;
  const lower = label.toLowerCase();

  return (
    <div
      className={`dv-pager ${className}`.trim()}
      role="group"
      aria-label={`Cambiar de ficha`}
    >
      <button
        type="button"
        className="dv-pager-btn"
        title={prev ? `${label} anterior` : `Es el primer ${lower}`}
        aria-label={`${label} anterior`}
        disabled={!prev || disabled}
        onClick={() => onChange?.(prev)}
      >
        ‹
      </button>
      <span className="dv-pager-count" aria-live="polite">
        {index + 1} / {items.length}
      </span>
      <button
        type="button"
        className="dv-pager-btn"
        title={next ? `${label} siguiente` : `Es el último ${lower}`}
        aria-label={`${label} siguiente`}
        disabled={!next || disabled}
        onClick={() => onChange?.(next)}
      >
        ›
      </button>
    </div>
  );
}
